export const SET_PICKUP_PERSON_FORM = 'SET_PICKUP_PERSON_FORM'
export const RESET_PICKUP_PERSON_FORM = 'RESET_PICKUP_PERSON_FORM'
export const SET_PICKUP_PERSON_FORM_FIELD = 'SET_PICKUP_PERSON_FORM_FIELD'
